const countries = require('../data/countries');

/* This function will find the country that has the same lang key from contentful */
function getCountryByLang(key) {
  return Object.values(countries).find(country => country.lang === key);
}

module.exports = getCountryByLang;
